import Image from 'next/image';

export type AspectRatio = {
  name: AspectName;
  value: string;
  svg: React.ReactNode;
  width: number;
  height: number;
};

export const aspectRatios: AspectRatio[] = [
  {
    name: 'Freeform',
    value: 'Freeform',
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
      >
        <path
          d='M37.5 30C37.5 30.3315 37.3683 30.6495 37.1339 30.8839C36.8995 31.1183 36.5815 31.25 36.25 31.25H31.25V36.25C31.25 36.5815 31.1183 36.8995 30.8839 37.1339C30.6495 37.3683 30.3315 37.5 30 37.5C29.6685 37.5 29.3505 37.3683 29.1161 37.1339C28.8817 36.8995 28.75 36.5815 28.75 36.25V31.25H10C9.66848 31.25 9.35054 31.1183 9.11612 30.8839C8.8817 30.6495 8.75 30.3315 8.75 30V11.25H3.75C3.41848 11.25 3.10054 11.1183 2.86612 10.8839C2.6317 10.6495 2.5 10.3315 2.5 10C2.5 9.66848 2.6317 9.35054 2.86612 9.11612C3.10054 8.8817 3.41848 8.75 3.75 8.75H8.75V3.75C8.75 3.41848 8.8817 3.10054 9.11612 2.86612C9.35054 2.6317 9.66848 2.5 10 2.5C10.3315 2.5 10.6495 2.6317 10.8839 2.86612C11.1183 3.10054 11.25 3.41848 11.25 3.75V28.75H36.25C36.5815 28.75 36.8995 28.8817 37.1339 29.1161C37.3683 29.3505 37.5 29.6685 37.5 30ZM15 11.25H28.75V25C28.75 25.3315 28.8817 25.6495 29.1161 25.8839C29.3505 26.1183 29.6685 26.25 30 26.25C30.3315 26.25 30.6495 26.1183 30.8839 25.8839C31.1183 25.6495 31.25 25.3315 31.25 25V10C31.25 9.66848 31.1183 9.35054 30.8839 9.11612C30.6495 8.8817 30.3315 8.75 30 8.75H15C14.6685 8.75 14.3505 8.8817 14.1161 9.11612C13.8817 9.35054 13.75 9.66848 13.75 10C13.75 10.3315 13.8817 10.6495 14.1161 10.8839C14.3505 11.1183 14.6685 11.25 15 11.25Z'
          fill='#252933'
        />
      </svg>
    ),
    width: 0,
    height: 0,
  },
  {
    name: 'Instagram Story',
    value: 'Instagram Story',
    svg: (
      <svg
        width='40'
        height='70'
        viewBox='0 0 40 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H38C38.8284 0.5 39.5 1.17157 39.5 2V68C39.5 68.8284 38.8284 69.5 38 69.5H2C1.17157 69.5 0.5 68.8284 0.5 68V2Z'
          stroke='#C235B1'
        />
        <g clipPath='url(#clip0_5681_3005)'>
          <path
            d='M25.3125 25H14.6875C12.0987 25 10 27.0987 10 29.6875V40.3125C10 42.9013 12.0987 45 14.6875 45H25.3125C27.9013 45 30 42.9013 30 40.3125V29.6875C30 27.0987 27.9013 25 25.3125 25Z'
            fill='url(#paint0_radial_5681_3005)'
          />
          <path
            d='M25.3125 25H14.6875C12.0987 25 10 27.0987 10 29.6875V40.3125C10 42.9013 12.0987 45 14.6875 45H25.3125C27.9013 45 30 42.9013 30 40.3125V29.6875C30 27.0987 27.9013 25 25.3125 25Z'
            fill='url(#paint1_radial_5681_3005)'
          />
          <path
            d='M20.0007 27.1875C17.879 27.1875 17.6127 27.1968 16.7793 27.2347C15.9476 27.2728 15.3799 27.4045 14.8832 27.5977C14.3693 27.7972 13.9334 28.0641 13.4992 28.4985C13.0646 28.9328 12.7977 29.3687 12.5975 29.8824C12.4038 30.3793 12.272 30.9471 12.2345 31.7785C12.1973 32.6119 12.1875 32.8783 12.1875 35.0001C12.1875 37.1219 12.1969 37.3873 12.2347 38.2206C12.273 39.0523 12.4046 39.6201 12.5977 40.1168C12.7974 40.6307 13.0643 41.0666 13.4987 41.5008C13.9328 41.9354 14.3687 42.203 14.8822 42.4025C15.3793 42.5957 15.9471 42.7273 16.7787 42.7655C17.612 42.8034 17.8781 42.8127 19.9998 42.8127C22.1217 42.8127 22.3872 42.8034 23.2205 42.7655C24.0522 42.7273 24.6205 42.5957 25.1177 42.4025C25.6313 42.203 26.0666 41.9354 26.5006 41.5008C26.9352 41.0666 27.2021 40.6307 27.4023 40.117C27.5944 39.6201 27.7262 39.0522 27.7653 38.2208C27.8027 37.3875 27.8125 37.1219 27.8125 35.0001C27.8125 32.8783 27.8027 32.612 27.7653 31.7787C27.7262 30.947 27.5944 30.3793 27.4023 29.8825C27.2021 29.3687 26.9352 28.9328 26.5006 28.4985C26.0661 28.064 25.6315 27.797 25.1172 27.5977C24.6191 27.4045 24.0511 27.2728 23.2194 27.2347C22.386 27.1968 22.1207 27.1875 19.9983 27.1875H20.0007ZM19.2998 28.5954C19.5079 28.5951 19.74 28.5954 20.0007 28.5954C22.0867 28.5954 22.3339 28.6029 23.1577 28.6403C23.9194 28.6751 24.3328 28.8024 24.6082 28.9094C24.9728 29.051 25.2327 29.2202 25.506 29.4937C25.7795 29.7671 25.9487 30.0275 26.0906 30.3921C26.1976 30.6672 26.325 31.0806 26.3597 31.8423C26.3971 32.6659 26.4052 32.9133 26.4052 34.9983C26.4052 37.0833 26.3971 37.3307 26.3597 38.1542C26.3248 38.9159 26.1976 39.3294 26.0906 39.6045C25.9491 39.9691 25.7795 40.2287 25.506 40.502C25.2326 40.7754 24.973 40.9446 24.6082 41.0863C24.3331 41.1937 23.9194 41.3206 23.1577 41.3555C22.3341 41.3929 22.0867 41.401 20.0007 41.401C17.9146 41.401 17.6674 41.3929 16.8438 41.3555C16.0821 41.3203 15.6687 41.193 15.3931 41.0861C15.0285 40.9445 14.7681 40.7752 14.4947 40.5018C14.2212 40.2284 14.0519 39.9686 13.91 39.6038C13.8031 39.3287 13.6756 38.9153 13.641 38.1536C13.6035 37.33 13.596 37.0827 13.596 34.9963C13.596 32.9101 13.6035 32.664 13.641 31.8404C13.6758 31.0787 13.8031 30.6652 13.91 30.3898C14.0516 30.0253 14.2212 29.7648 14.4947 29.4914C14.7681 29.218 15.0285 29.0487 15.3931 28.9068C15.6685 28.7993 16.0821 28.6724 16.8438 28.6374C17.5645 28.6048 17.8438 28.5951 19.2998 28.5934V28.5954ZM24.171 29.8926C23.6534 29.8926 23.2335 30.312 23.2335 30.8298C23.2335 31.3474 23.6534 31.7673 24.171 31.7673C24.6886 31.7673 25.1085 31.3474 25.1085 30.8298C25.1085 30.3122 24.6886 29.8923 24.171 29.8923V29.8926ZM20.0007 30.988C17.7851 30.988 15.9886 32.7844 15.9886 35.0001C15.9886 37.2158 17.7851 39.0113 20.0007 39.0113C22.2164 39.0113 24.0122 37.2158 24.0122 35.0001C24.0122 32.7844 22.2163 30.988 20.0005 30.988H20.0007ZM20.0007 32.3959C21.4389 32.3959 22.6049 33.5617 22.6049 35.0001C22.6049 36.4383 21.4389 37.6043 20.0007 37.6043C18.5624 37.6043 17.3965 36.4383 17.3965 35.0001C17.3965 33.5617 18.5624 32.3959 20.0007 32.3959Z'
            fill='white'
          />
        </g>
        <defs>
          <radialGradient
            id='paint0_radial_5681_3005'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(15.3125 46.5404) rotate(-90) scale(19.8215 18.4355)'
          >
            <stop stopColor='#FFDD55' />
            <stop offset='0.1' stopColor='#FFDD55' />
            <stop offset='0.5' stopColor='#FF543E' />
            <stop offset='1' stopColor='#C837AB' />
          </radialGradient>
          <radialGradient
            id='paint1_radial_5681_3005'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(6.64989 26.4408) rotate(78.6806) scale(8.86031 36.5225)'
          >
            <stop stopColor='#3771C8' />
            <stop offset='0.128' stopColor='#3771C8' />
            <stop offset='1' stopColor='#6600FF' stopOpacity='0' />
          </radialGradient>
          <clipPath id='clip0_5681_3005'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(10 25)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    width: 1080,
    height: 1920,
  },
  {
    name: 'Instagram Post',
    value: 'Instagram Post',
    svg: (
      <svg
        width='56'
        height='70'
        viewBox='0 0 56 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H54C54.8284 0.5 55.5 1.17157 55.5 2V68C55.5 68.8284 54.8284 69.5 54 69.5H2C1.17157 69.5 0.5 68.8284 0.5 68V2Z'
          stroke='#C235B1'
        />
        <g clipPath='url(#clip0_5681_3013)'>
          <path
            d='M33.3125 25H22.6875C20.0987 25 18 27.0987 18 29.6875V40.3125C18 42.9013 20.0987 45 22.6875 45H33.3125C35.9013 45 38 42.9013 38 40.3125V29.6875C38 27.0987 35.9013 25 33.3125 25Z'
            fill='url(#paint0_radial_5681_3013)'
          />
          <path
            d='M33.3125 25H22.6875C20.0987 25 18 27.0987 18 29.6875V40.3125C18 42.9013 20.0987 45 22.6875 45H33.3125C35.9013 45 38 42.9013 38 40.3125V29.6875C38 27.0987 35.9013 25 33.3125 25Z'
            fill='url(#paint1_radial_5681_3013)'
          />
          <path
            d='M28.0007 27.1875C25.879 27.1875 25.6127 27.1968 24.7793 27.2347C23.9476 27.2728 23.3799 27.4045 22.8832 27.5977C22.3693 27.7972 21.9334 28.0641 21.4992 28.4985C21.0646 28.9328 20.7977 29.3687 20.5975 29.8824C20.4038 30.3793 20.272 30.9471 20.2345 31.7785C20.1973 32.6119 20.1875 32.8783 20.1875 35.0001C20.1875 37.1219 20.1969 37.3873 20.2347 38.2206C20.273 39.0523 20.4046 39.6201 20.5977 40.1168C20.7974 40.6307 21.0643 41.0666 21.4987 41.5008C21.9328 41.9354 22.3687 42.203 22.8822 42.4025C23.3793 42.5957 23.9471 42.7273 24.7787 42.7655C25.612 42.8034 25.8781 42.8127 27.9998 42.8127C30.1217 42.8127 30.3872 42.8034 31.2205 42.7655C32.0522 42.7273 32.6205 42.5957 33.1177 42.4025C33.6313 42.203 34.0666 41.9354 34.5006 41.5008C34.9352 41.0666 35.2021 40.6307 35.4023 40.117C35.5944 39.6201 35.7262 39.0522 35.7653 38.2208C35.8027 37.3875 35.8125 37.1219 35.8125 35.0001C35.8125 32.8783 35.8027 32.612 35.7653 31.7787C35.7262 30.947 35.5944 30.3793 35.4023 29.8825C35.2021 29.3687 34.9352 28.9328 34.5006 28.4985C34.0661 28.064 33.6315 27.797 33.1172 27.5977C32.6191 27.4045 32.0511 27.2728 31.2194 27.2347C30.386 27.1968 30.1207 27.1875 27.9983 27.1875H28.0007ZM27.2998 28.5954C27.5079 28.5951 27.74 28.5954 28.0007 28.5954C30.0867 28.5954 30.3339 28.6029 31.1577 28.6403C31.9194 28.6751 32.3328 28.8024 32.6082 28.9094C32.9728 29.051 33.2327 29.2202 33.506 29.4937C33.7795 29.7671 33.9487 30.0275 34.0906 30.3921C34.1976 30.6672 34.325 31.0806 34.3597 31.8423C34.3971 32.6659 34.4052 32.9133 34.4052 34.9983C34.4052 37.0833 34.3971 37.3307 34.3597 38.1542C34.3248 38.9159 34.1976 39.3294 34.0906 39.6045C33.9491 39.9691 33.7795 40.2287 33.506 40.502C33.2326 40.7754 32.973 40.9446 32.6082 41.0863C32.3331 41.1937 31.9194 41.3206 31.1577 41.3555C30.3341 41.3929 30.0867 41.401 28.0007 41.401C25.9146 41.401 25.6674 41.3929 24.8438 41.3555C24.0821 41.3203 23.6687 41.193 23.3931 41.0861C23.0285 40.9445 22.7681 40.7752 22.4947 40.5018C22.2212 40.2284 22.0519 39.9686 21.91 39.6038C21.8031 39.3287 21.6756 38.9153 21.641 38.1536C21.6035 37.33 21.596 37.0827 21.596 34.9963C21.596 32.9101 21.6035 32.664 21.641 31.8404C21.6758 31.0787 21.8031 30.6652 21.91 30.3898C22.0516 30.0253 22.2212 29.7648 22.4947 29.4914C22.7681 29.218 23.0285 29.0487 23.3931 28.9068C23.6685 28.7993 24.0821 28.6724 24.8438 28.6374C25.5645 28.6048 25.8438 28.5951 27.2998 28.5934V28.5954ZM32.171 29.8926C31.6534 29.8926 31.2335 30.312 31.2335 30.8298C31.2335 31.3474 31.6534 31.7673 32.171 31.7673C32.6886 31.7673 33.1085 31.3474 33.1085 30.8298C33.1085 30.3122 32.6886 29.8923 32.171 29.8923V29.8926ZM28.0007 30.988C25.7851 30.988 23.9886 32.7844 23.9886 35.0001C23.9886 37.2158 25.7851 39.0113 28.0007 39.0113C30.2164 39.0113 32.0122 37.2158 32.0122 35.0001C32.0122 32.7844 30.2163 30.988 28.0005 30.988H28.0007ZM28.0007 32.3959C29.4389 32.3959 30.6049 33.5617 30.6049 35.0001C30.6049 36.4383 29.4389 37.6043 28.0007 37.6043C26.5624 37.6043 25.3965 36.4383 25.3965 35.0001C25.3965 33.5617 26.5624 32.3959 28.0007 32.3959Z'
            fill='white'
          />
        </g>
        <defs>
          <radialGradient
            id='paint0_radial_5681_3013'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(23.3125 46.5404) rotate(-90) scale(19.8215 18.4355)'
          >
            <stop stopColor='#FFDD55' />
            <stop offset='0.1' stopColor='#FFDD55' />
            <stop offset='0.5' stopColor='#FF543E' />
            <stop offset='1' stopColor='#C837AB' />
          </radialGradient>
          <radialGradient
            id='paint1_radial_5681_3013'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(14.6499 26.4408) rotate(78.6806) scale(8.86031 36.5225)'
          >
            <stop stopColor='#3771C8' />
            <stop offset='0.128' stopColor='#3771C8' />
            <stop offset='1' stopColor='#6600FF' stopOpacity='0' />
          </radialGradient>
          <clipPath id='clip0_5681_3013'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(18 25)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    width: 1080,
    height: 1350,
  },
  {
    name: 'Instagram Reel',
    value: 'Instagram Reel',
    svg: (
      <svg
        width='40'
        height='70'
        viewBox='0 0 40 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1 2C1 1.17157 1.67157 0.5 2.5 0.5H37.5C38.3284 0.5 39 1.17157 39 2V68C39 68.8284 38.3284 69.5 37.5 69.5H2.5C1.67157 69.5 1 68.8284 1 68V2Z'
          stroke='#C235B1'
        />
        <g clipPath='url(#clip0_5681_3021)'>
          <path
            d='M25.3125 25H14.6875C12.0987 25 10 27.0987 10 29.6875V40.3125C10 42.9013 12.0987 45 14.6875 45H25.3125C27.9013 45 30 42.9013 30 40.3125V29.6875C30 27.0987 27.9013 25 25.3125 25Z'
            fill='url(#paint0_radial_5681_3021)'
          />
          <path
            d='M25.3125 25H14.6875C12.0987 25 10 27.0987 10 29.6875V40.3125C10 42.9013 12.0987 45 14.6875 45H25.3125C27.9013 45 30 42.9013 30 40.3125V29.6875C30 27.0987 27.9013 25 25.3125 25Z'
            fill='url(#paint1_radial_5681_3021)'
          />
          <path
            d='M20.0007 27.1875C17.879 27.1875 17.6127 27.1968 16.7793 27.2347C15.9476 27.2728 15.3799 27.4045 14.8832 27.5977C14.3693 27.7972 13.9334 28.0641 13.4992 28.4985C13.0646 28.9328 12.7977 29.3687 12.5975 29.8824C12.4038 30.3793 12.272 30.9471 12.2345 31.7785C12.1973 32.6119 12.1875 32.8783 12.1875 35.0001C12.1875 37.1219 12.1969 37.3873 12.2347 38.2206C12.273 39.0523 12.4046 39.6201 12.5977 40.1168C12.7974 40.6307 13.0643 41.0666 13.4987 41.5008C13.9328 41.9354 14.3687 42.203 14.8822 42.4025C15.3793 42.5957 15.9471 42.7273 16.7787 42.7655C17.612 42.8034 17.8781 42.8127 19.9998 42.8127C22.1217 42.8127 22.3872 42.8034 23.2205 42.7655C24.0522 42.7273 24.6205 42.5957 25.1177 42.4025C25.6313 42.203 26.0666 41.9354 26.5006 41.5008C26.9352 41.0666 27.2021 40.6307 27.4023 40.117C27.5944 39.6201 27.7262 39.0522 27.7653 38.2208C27.8027 37.3875 27.8125 37.1219 27.8125 35.0001C27.8125 32.8783 27.8027 32.612 27.7653 31.7787C27.7262 30.947 27.5944 30.3793 27.4023 29.8825C27.2021 29.3687 26.9352 28.9328 26.5006 28.4985C26.0661 28.064 25.6315 27.797 25.1172 27.5977C24.6191 27.4045 24.0511 27.2728 23.2194 27.2347C22.386 27.1968 22.1207 27.1875 19.9983 27.1875H20.0007ZM19.2998 28.5954C19.5079 28.5951 19.74 28.5954 20.0007 28.5954C22.0867 28.5954 22.3339 28.6029 23.1577 28.6403C23.9194 28.6751 24.3328 28.8024 24.6082 28.9094C24.9728 29.051 25.2327 29.2202 25.506 29.4937C25.7795 29.7671 25.9487 30.0275 26.0906 30.3921C26.1976 30.6672 26.325 31.0806 26.3597 31.8423C26.3971 32.6659 26.4052 32.9133 26.4052 34.9983C26.4052 37.0833 26.3971 37.3307 26.3597 38.1542C26.3248 38.9159 26.1976 39.3294 26.0906 39.6045C25.9491 39.9691 25.7795 40.2287 25.506 40.502C25.2326 40.7754 24.973 40.9446 24.6082 41.0863C24.3331 41.1937 23.9194 41.3206 23.1577 41.3555C22.3341 41.3929 22.0867 41.401 20.0007 41.401C17.9146 41.401 17.6674 41.3929 16.8438 41.3555C16.0821 41.3203 15.6687 41.193 15.3931 41.0861C15.0285 40.9445 14.7681 40.7752 14.4947 40.5018C14.2212 40.2284 14.0519 39.9686 13.91 39.6038C13.8031 39.3287 13.6756 38.9153 13.641 38.1536C13.6035 37.33 13.596 37.0827 13.596 34.9963C13.596 32.9101 13.6035 32.664 13.641 31.8404C13.6758 31.0787 13.8031 30.6652 13.91 30.3898C14.0516 30.0253 14.2212 29.7648 14.4947 29.4914C14.7681 29.218 15.0285 29.0487 15.3931 28.9068C15.6685 28.7993 16.0821 28.6724 16.8438 28.6374C17.5645 28.6048 17.8438 28.5951 19.2998 28.5934V28.5954ZM24.171 29.8926C23.6534 29.8926 23.2335 30.312 23.2335 30.8298C23.2335 31.3474 23.6534 31.7673 24.171 31.7673C24.6886 31.7673 25.1085 31.3474 25.1085 30.8298C25.1085 30.3122 24.6886 29.8923 24.171 29.8923V29.8926ZM20.0007 30.988C17.7851 30.988 15.9886 32.7844 15.9886 35.0001C15.9886 37.2158 17.7851 39.0113 20.0007 39.0113C22.2164 39.0113 24.0122 37.2158 24.0122 35.0001C24.0122 32.7844 22.2163 30.988 20.0005 30.988H20.0007ZM20.0007 32.3959C21.4389 32.3959 22.6049 33.5617 22.6049 35.0001C22.6049 36.4383 21.4389 37.6043 20.0007 37.6043C18.5624 37.6043 17.3965 36.4383 17.3965 35.0001C17.3965 33.5617 18.5624 32.3959 20.0007 32.3959Z'
            fill='white'
          />
        </g>
        <defs>
          <radialGradient
            id='paint0_radial_5681_3021'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(15.3125 46.5404) rotate(-90) scale(19.8215 18.4355)'
          >
            <stop stopColor='#FFDD55' />
            <stop offset='0.1' stopColor='#FFDD55' />
            <stop offset='0.5' stopColor='#FF543E' />
            <stop offset='1' stopColor='#C837AB' />
          </radialGradient>
          <radialGradient
            id='paint1_radial_5681_3021'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(6.64989 26.4408) rotate(78.6806) scale(8.86031 36.5225)'
          >
            <stop stopColor='#3771C8' />
            <stop offset='0.128' stopColor='#3771C8' />
            <stop offset='1' stopColor='#6600FF' stopOpacity='0' />
          </radialGradient>
          <clipPath id='clip0_5681_3021'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(10 25)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    width: 1080,
    height: 1920,
  },
  {
    name: 'TikTok Video',
    value: 'TikTok Video',
    svg: (
      <svg
        width='40'
        height='70'
        viewBox='0 0 40 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1 2C1 1.17157 1.67157 0.5 2.5 0.5H37.5C38.3284 0.5 39 1.17157 39 2V68C39 68.8284 38.3284 69.5 37.5 69.5H2.5C1.67157 69.5 1 68.8284 1 68V2Z'
          stroke='black'
        />
        <g clipPath='url(#clip0_5681_3029)'>
          <path
            d='M24.8223 31.7817C26.2816 32.8401 28.0692 33.4629 29.9999 33.4629V29.6932C29.6345 29.6933 29.27 29.6546 28.9126 29.5777V32.545C26.982 32.545 25.1946 31.9223 23.735 30.864V38.5568C23.735 42.4052 20.6604 45.5246 16.8679 45.5246C15.4528 45.5246 14.1375 45.0906 13.0449 44.3461C14.2919 45.6398 16.031 46.4424 17.9549 46.4424C21.7477 46.4424 24.8225 43.3229 24.8225 39.4744V31.7817H24.8223ZM26.1637 27.9786C25.4179 27.1519 24.9283 26.0836 24.8223 24.9026V24.4177H23.792C24.0513 25.9188 24.936 27.2013 26.1637 27.9786ZM15.4437 41.393C15.027 40.8387 14.8019 40.1606 14.8029 39.4634C14.8029 37.7033 16.2092 36.2762 17.9442 36.2762C18.2676 36.2761 18.589 36.3264 18.8971 36.4256V32.5716C18.537 32.5216 18.1736 32.5003 17.8103 32.5081V35.5078C17.5019 35.4086 17.1803 35.3582 16.8569 35.3585C15.1219 35.3585 13.7157 36.7855 13.7157 38.5458C13.7157 39.7905 14.4186 40.8681 15.4437 41.393Z'
            fill='#FF004F'
          />
          <path
            d='M23.7343 30.8639C25.1939 31.9222 26.9812 32.5449 28.9118 32.5449V29.5777C27.8342 29.3448 26.8802 28.7734 26.1629 27.9786C24.9351 27.2012 24.0505 25.9188 23.7912 24.4177H21.0846V39.4743C21.0785 41.2295 19.6746 42.6508 17.9433 42.6508C16.9231 42.6508 16.0167 42.1574 15.4427 41.393C14.4177 40.8681 13.7147 39.7904 13.7147 38.5459C13.7147 36.7857 15.121 35.3586 16.856 35.3586C17.1884 35.3586 17.5088 35.4111 17.8094 35.5079V32.5082C14.0834 32.5863 11.0869 35.6753 11.0869 39.4743C11.0869 41.3708 11.8331 43.09 13.0442 44.3462C14.1368 45.0906 15.4521 45.5247 16.8672 45.5247C20.6598 45.5247 23.7343 42.4051 23.7343 38.5568L23.7343 30.8639Z'
            fill='black'
          />
          <path
            d='M28.9121 29.5776V28.7753C27.9404 28.7768 26.9877 28.5007 26.1632 27.9785C26.8931 28.7892 27.8541 29.3483 28.9121 29.5776ZM23.7915 24.4177C23.7668 24.2742 23.7478 24.1298 23.7346 23.9849V23.5H19.9976V38.5567C19.9916 40.3117 18.5878 41.733 16.8563 41.733C16.348 41.733 15.868 41.6106 15.443 41.393C16.017 42.1573 16.9234 42.6507 17.9436 42.6507C19.6748 42.6507 21.0789 41.2296 21.085 39.4743V24.4177H23.7915ZM17.8098 32.5081V31.654C17.4976 31.6107 17.1828 31.589 16.8676 31.5891C13.0746 31.5891 10 34.7087 10 38.5567C10 40.9692 11.2084 43.0953 13.0446 44.346C11.8335 43.0899 11.0873 41.3706 11.0873 39.4742C11.0873 35.6752 14.0838 32.5862 17.8098 32.5081Z'
            fill='#00F2EA'
          />
        </g>
        <defs>
          <clipPath id='clip0_5681_3029'>
            <rect
              width='20'
              height='23'
              fill='white'
              transform='translate(10 23.5)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    width: 1080,
    height: 1920,
  },
  {
    name: 'Facebook Post',
    value: 'Facebook Post',
    svg: (
      <svg
        width='70'
        height='58'
        viewBox='0 0 70 58'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H68C68.8284 0.5 69.5 1.17157 69.5 2V56C69.5 56.8284 68.8284 57.5 68 57.5H2C1.17157 57.5 0.5 56.8284 0.5 56V2Z'
          stroke='#1877F2'
        />
        <g clipPath='url(#clip0_5681_3038)'>
          <path
            d='M45 29C45 23.4771 40.5229 19 35 19C29.4771 19 25 23.4771 25 29C25 33.9913 28.6569 38.1283 33.4375 38.8785V31.8906H30.8984V29H33.4375V26.7969C33.4375 24.2906 34.9304 22.9063 37.2146 22.9063C38.3087 22.9063 39.4531 23.1016 39.4531 23.1016V25.5625H38.1921C36.9499 25.5625 36.5625 26.3333 36.5625 27.1242V29H39.3359L38.8926 31.8906H36.5625V38.8785C41.3431 38.1283 45 33.9913 45 29Z'
            fill='#1877F2'
          />
          <path
            d='M38.8926 31.8906L39.3359 29H36.5625V27.1242C36.5625 26.3333 36.9499 25.5625 38.1921 25.5625H39.4531V23.1016C39.4531 23.1016 38.3087 22.9062 37.2146 22.9062C34.9304 22.9062 33.4375 24.2906 33.4375 26.7969V29H30.8984V31.8906H33.4375V38.8785C33.9466 38.9584 34.4684 39 35 39C35.5316 39 36.0534 38.9584 36.5625 38.8785V31.8906H38.8926Z'
            fill='white'
          />
        </g>
        <defs>
          <clipPath id='clip0_5681_3038'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(25 19)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    width: 940,
    height: 788,
  },
  {
    name: 'Facebook Cover',
    value: 'Facebook Cover',
    svg: (
      <svg
        width='70'
        height='26'
        viewBox='0 0 70 26'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H68C68.8284 0.5 69.5 1.17157 69.5 2V24C69.5 24.8284 68.8284 25.5 68 25.5H2C1.17157 25.5 0.5 24.8284 0.5 24V2Z'
          stroke='#1877F2'
        />
        <g clipPath='url(#clip0_5681_3046)'>
          <path
            d='M45 13C45 7.47715 40.5229 3 35 3C29.4771 3 25 7.47715 25 13C25 17.9913 28.6569 22.1283 33.4375 22.8785V15.8906H30.8984V13H33.4375V10.7969C33.4375 8.29062 34.9304 6.90625 37.2146 6.90625C38.3087 6.90625 39.4531 7.10156 39.4531 7.10156V9.5625H38.1921C36.9499 9.5625 36.5625 10.3333 36.5625 11.1242V13H39.3359L38.8926 15.8906H36.5625V22.8785C41.3431 22.1283 45 17.9913 45 13Z'
            fill='#1877F2'
          />
          <path
            d='M38.8926 15.8906L39.3359 13H36.5625V11.1242C36.5625 10.3333 36.9499 9.5625 38.1921 9.5625H39.4531V7.10156C39.4531 7.10156 38.3087 6.90625 37.2146 6.90625C34.9304 6.90625 33.4375 8.29063 33.4375 10.7969V13H30.8984V15.8906H33.4375V22.8785C33.9466 22.9584 34.4684 23 35 23C35.5316 23 36.0534 22.9584 36.5625 22.8785V15.8906H38.8926Z'
            fill='white'
          />
        </g>
        <defs>
          <clipPath id='clip0_5681_3046'>
            <rect
              width='20'
              height='20'
              fill='white'
              transform='translate(25 3)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    width: 851,
    height: 315,
  },
  {
    name: 'Youtube Thumbnail',
    value: 'Youtube Thumbnail',
    svg: (
      <svg
        width='70'
        height='40'
        viewBox='0 0 70 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2.5C0.5 1.67157 1.17157 1 2 1H68C68.8284 1 69.5 1.67157 69.5 2.5V37.5C69.5 38.3284 68.8284 39 68 39H2C1.17157 39 0.5 38.3284 0.5 37.5V2.5Z'
          stroke='#FF0000'
        />
        <path
          d='M44.5586 15.2096C44.3252 14.3405 43.6513 13.6616 42.7885 13.4264C41.2365 13 34.9899 13 34.9899 13C34.9899 13 28.7433 13.0129 27.1912 13.4393C26.3285 13.6745 25.6546 14.3534 25.4211 15.2225C24.9517 18.0007 24.7695 22.2339 25.434 24.9009C25.6674 25.77 26.3413 26.449 27.2041 26.6841C28.7561 27.1106 35.0027 27.1106 35.0027 27.1106C35.0027 27.1106 41.2493 27.1106 42.8014 26.6841C43.6641 26.449 44.338 25.77 44.5715 24.9009C45.0666 22.1189 45.2192 17.8883 44.5586 15.2096Z'
          fill='#FF0000'
        />
        <path
          d='M33.002 23.079L38.184 20.0553L33.002 17.0316V23.079Z'
          fill='white'
        />
      </svg>
    ),
    width: 1280,
    height: 720,
  },
  {
    name: 'Youtube Intro',
    value: 'Youtube Intro',
    svg: (
      <svg
        width='70'
        height='40'
        viewBox='0 0 70 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2.5C0.5 1.67157 1.17157 1 2 1H68C68.8284 1 69.5 1.67157 69.5 2.5V37.5C69.5 38.3284 68.8284 39 68 39H2C1.17157 39 0.5 38.3284 0.5 37.5V2.5Z'
          stroke='#FF0000'
        />
        <path
          d='M44.5586 15.2096C44.3252 14.3405 43.6513 13.6616 42.7885 13.4264C41.2365 13 34.9899 13 34.9899 13C34.9899 13 28.7433 13.0129 27.1912 13.4393C26.3285 13.6745 25.6546 14.3534 25.4211 15.2225C24.9517 18.0007 24.7695 22.2339 25.434 24.9009C25.6674 25.77 26.3413 26.449 27.2041 26.6841C28.7561 27.1106 35.0027 27.1106 35.0027 27.1106C35.0027 27.1106 41.2493 27.1106 42.8014 26.6841C43.6641 26.449 44.338 25.77 44.5715 24.9009C45.0666 22.1189 45.2192 17.8883 44.5586 15.2096Z'
          fill='#FF0000'
        />
        <path
          d='M33.002 23.079L38.184 20.0553L33.002 17.0316V23.079Z'
          fill='white'
        />
      </svg>
    ),
    width: 1920,
    height: 1080,
  },
  {
    name: 'LinkedIn Background',
    value: 'LinkedIn Background',
    svg: (
      <svg
        width='80'
        height='20'
        viewBox='0 0 80 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H78C78.8284 0.5 79.5 1.17157 79.5 2V18C79.5 18.8284 78.8284 19.5 78 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V2Z'
          stroke='#0A66C2'
        />
        <g clipPath='url(#clip0_5681_3070)'>
          <path
            d='M44.25 2H35.75C33.6789 2 32 3.67893 32 5.75V14.25C32 16.3211 33.6789 18 35.75 18H44.25C46.3211 18 48 16.3211 48 14.25V5.75C48 3.67893 46.3211 2 44.25 2Z'
            fill='white'
          />
          <path
            d='M44.25 2H35.75C33.6789 2 32 3.67893 32 5.75V14.25C32 16.3211 33.6789 18 35.75 18H44.25C46.3211 18 48 16.3211 48 14.25V5.75C48 3.67893 46.3211 2 44.25 2Z'
            fill='#0A66C2'
          />
          <path
            d='M43.545 15.6053H45.3743C45.5124 15.6053 45.6243 15.4934 45.6243 15.3554L45.6253 11.4902C45.6253 9.47006 45.19 7.91721 42.8292 7.91721C41.9317 7.88389 41.0854 8.3465 40.6287 9.119C40.6251 9.12512 40.6186 9.12887 40.6115 9.12887C40.6005 9.12887 40.5915 9.11993 40.5915 9.10893V8.35375C40.5915 8.21569 40.4797 8.10376 40.3415 8.10376H38.6055C38.4674 8.10376 38.3555 8.21569 38.3555 8.35375V15.355C38.3555 15.4931 38.4674 15.605 38.6055 15.605H40.4347C40.5728 15.605 40.6847 15.4931 40.6847 15.355V11.8942C40.6847 10.9156 40.8703 9.96793 42.0835 9.96793C43.2795 9.96793 43.295 11.0877 43.295 11.9576V15.3553C43.295 15.4934 43.4069 15.6053 43.545 15.6053Z'
            fill='white'
          />
          <path
            d='M34.375 5.72672C34.375 6.46826 34.9855 7.07837 35.727 7.07837C36.4684 7.0783 37.0784 6.46783 37.0784 5.72644C37.0783 4.98504 36.4682 4.375 35.7267 4.375C34.9852 4.375 34.375 4.98519 34.375 5.72672Z'
            fill='white'
          />
          <path
            d='M34.8096 15.6053H36.6413C36.7793 15.6053 36.8913 15.4934 36.8913 15.3553V8.35375C36.8913 8.21569 36.7793 8.10376 36.6413 8.10376H34.8096C34.6715 8.10376 34.5596 8.21569 34.5596 8.35375V15.3553C34.5596 15.4934 34.6715 15.6053 34.8096 15.6053Z'
            fill='white'
          />
        </g>
        <defs>
          <clipPath id='clip0_5681_3070'>
            <rect
              width='16'
              height='16'
              fill='white'
              transform='translate(32 2)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    width: 1584,
    height: 396,
  },
  {
    name: 'Presentation',
    value: 'Presentation-16:9',
    svg: (
      <svg
        width='70'
        height='40'
        viewBox='0 0 70 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2.5C0.5 1.67157 1.17157 1 2 1H68C68.8284 1 69.5 1.67157 69.5 2.5V37.5C69.5 38.3284 68.8284 39 68 39H2C1.17157 39 0.5 38.3284 0.5 37.5V2.5Z'
          stroke='#FF6105'
        />
        <path
          d='M25.4496 24V17.928H23.6496V16.884H24.3816C24.7016 16.884 24.9616 16.844 25.1616 16.764C25.3616 16.676 25.5056 16.532 25.5936 16.332C25.6816 16.124 25.7256 15.84 25.7256 15.48H26.7456V24H25.4496ZM31.744 24.192C31.072 24.192 30.504 24.044 30.04 23.748C29.576 23.444 29.224 23.008 28.984 22.44C28.744 21.864 28.624 21.168 28.624 20.352C28.624 19.64 28.684 18.98 28.804 18.372C28.932 17.756 29.132 17.22 29.404 16.764C29.676 16.3 30.028 15.94 30.46 15.684C30.9 15.42 31.432 15.288 32.056 15.288C32.84 15.288 33.452 15.48 33.892 15.864C34.332 16.24 34.636 16.744 34.804 17.376L33.52 17.484C33.424 17.172 33.264 16.924 33.04 16.74C32.824 16.556 32.496 16.464 32.056 16.464C31.4 16.464 30.884 16.744 30.508 17.304C30.132 17.864 29.932 18.72 29.908 19.872L29.68 19.824C29.768 19.552 29.916 19.304 30.124 19.08C30.332 18.848 30.592 18.664 30.904 18.528C31.224 18.384 31.588 18.312 31.996 18.312C32.564 18.312 33.06 18.432 33.484 18.672C33.916 18.904 34.248 19.236 34.48 19.668C34.72 20.1 34.84 20.604 34.84 21.18C34.84 21.804 34.708 22.344 34.444 22.8C34.18 23.248 33.816 23.592 33.352 23.832C32.888 24.072 32.352 24.192 31.744 24.192ZM31.756 23.04C32.276 23.04 32.696 22.876 33.016 22.548C33.344 22.212 33.508 21.756 33.508 21.18C33.508 20.82 33.436 20.508 33.292 20.244C33.156 19.972 32.96 19.764 32.704 19.62C32.456 19.476 32.168 19.404 31.84 19.404C31.48 19.404 31.16 19.476 30.88 19.62C30.6 19.764 30.38 19.972 30.22 20.244C30.06 20.508 29.98 20.82 29.98 21.18C29.98 21.54 30.052 21.86 30.196 22.14C30.34 22.42 30.544 22.64 30.808 22.8C31.08 22.96 31.396 23.04 31.756 23.04ZM36.5769 24V22.488H38.1249V24H36.5769ZM36.5769 19.428V17.916H38.1249V19.428H36.5769ZM42.73 24.192C41.994 24.192 41.398 24.016 40.942 23.664C40.486 23.312 40.17 22.844 39.994 22.26L41.302 22.176C41.398 22.44 41.562 22.648 41.794 22.8C42.034 22.944 42.346 23.016 42.73 23.016C43.402 23.016 43.91 22.752 44.254 22.224C44.606 21.696 44.786 20.84 44.794 19.656L45.034 19.716C44.834 20.22 44.53 20.604 44.122 20.868C43.722 21.132 43.25 21.264 42.706 21.264C42.146 21.264 41.654 21.144 41.23 20.904C40.806 20.656 40.474 20.312 40.234 19.872C39.994 19.432 39.874 18.92 39.874 18.336C39.874 17.704 40.002 17.164 40.258 16.716C40.514 16.26 40.87 15.908 41.326 15.66C41.782 15.412 42.31 15.288 42.91 15.288C43.646 15.288 44.246 15.452 44.71 15.78C45.182 16.108 45.53 16.572 45.754 17.172C45.986 17.764 46.102 18.476 46.102 19.308C46.102 20.028 46.042 20.688 45.922 21.288C45.802 21.888 45.606 22.404 45.334 22.836C45.07 23.268 44.722 23.604 44.29 23.844C43.866 24.076 43.346 24.192 42.73 24.192ZM42.886 20.148C43.246 20.148 43.562 20.076 43.834 19.932C44.106 19.788 44.318 19.584 44.47 19.32C44.622 19.048 44.698 18.72 44.698 18.336C44.698 17.968 44.626 17.644 44.482 17.364C44.346 17.076 44.146 16.852 43.882 16.692C43.618 16.524 43.302 16.44 42.934 16.44C42.574 16.44 42.262 16.52 41.998 16.68C41.742 16.84 41.542 17.064 41.398 17.352C41.262 17.632 41.194 17.956 41.194 18.324C41.194 18.7 41.266 19.024 41.41 19.296C41.554 19.568 41.75 19.78 41.998 19.932C42.254 20.076 42.55 20.148 42.886 20.148Z'
          fill='#FF6105'
        />
      </svg>
    ),
    width: 1920,
    height: 1080,
  },
  {
    name: 'Presentation',
    value: 'Presentation-4:3',
    svg: (
      <svg
        width='70'
        height='54'
        viewBox='0 0 70 54'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2.5C0.5 1.67157 1.17157 1 2 1H68C68.8284 1 69.5 1.67157 69.5 2.5V51.5C69.5 52.3284 68.8284 53 68 53H2C1.17157 53 0.5 52.3284 0.5 51.5V2.5Z'
          stroke='#FF6105'
        />
        <path
          d='M30.4152 31V29.224H26.1192V28.12L30.2592 22.48H31.7112V28.048H32.7552V29.224H31.7112V31H30.4152ZM27.5952 28.048H30.4152V24.28L27.5952 28.048ZM34.1277 31V29.488H35.6757V31H34.1277ZM34.1277 26.428V24.916H35.6757V26.428H34.1277ZM40.4248 31.192C39.4408 31.192 38.6808 30.964 38.1448 30.508C37.6168 30.052 37.3328 29.452 37.2928 28.708L38.6248 28.636C38.6728 29.124 38.8568 29.476 39.1768 29.692C39.5048 29.9 39.9208 30.004 40.4248 30.004C40.7608 30.004 41.0688 29.96 41.3488 29.872C41.6368 29.776 41.8648 29.624 42.0328 29.416C42.2088 29.2 42.2968 28.92 42.2968 28.576C42.2968 28.064 42.1248 27.688 41.7808 27.448C41.4368 27.2 40.9808 27.076 40.4128 27.076H39.7048V25.948H40.4128C40.8688 25.948 41.2488 25.856 41.5528 25.672C41.8568 25.488 42.0088 25.168 42.0088 24.712C42.0088 24.312 41.8808 24.008 41.6248 23.8C41.3688 23.584 40.9768 23.476 40.4488 23.476C39.9368 23.476 39.5488 23.576 39.2848 23.776C39.0208 23.976 38.8648 24.248 38.8168 24.592L37.4848 24.52C37.5648 23.848 37.8568 23.308 38.3608 22.9C38.8728 22.492 39.5688 22.288 40.4488 22.288C41.0568 22.288 41.5768 22.384 42.0088 22.576C42.4408 22.76 42.7728 23.028 43.0048 23.38C43.2368 23.732 43.3528 24.144 43.3528 24.616C43.3528 25.136 43.1848 25.56 42.8488 25.888C42.5208 26.216 42.0368 26.44 41.3968 26.56V26.344C42.0928 26.432 42.6408 26.68 43.0408 27.088C43.4408 27.488 43.6408 28 43.6408 28.624C43.6408 29.16 43.5048 29.624 43.2328 30.016C42.9608 30.4 42.5848 30.692 42.1048 30.892C41.6248 31.092 41.0648 31.192 40.4248 31.192Z'
          fill='#FF6105'
        />
      </svg>
    ),
    width: 1024,
    height: 768,
  },
  {
    name: 'Poster',
    value: 'Poster',
    svg: (
      <svg
        width='54'
        height='70'
        viewBox='0 0 54 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1 2C1 1.17157 1.67157 0.5 2.5 0.5H51.5C52.3284 0.5 53 1.17157 53 2V68C53 68.8284 52.3284 69.5 51.5 69.5H2.5C1.67157 69.5 1 68.8284 1 68V2Z'
          stroke='#FF6105'
        />
        <path
          d='M21.4912 39.192C20.5072 39.192 19.7472 38.964 19.2112 38.508C18.6832 38.052 18.3992 37.452 18.3592 36.708L19.6912 36.636C19.7392 37.124 19.9232 37.476 20.2432 37.692C20.5712 37.9 20.9872 38.004 21.4912 38.004C21.8272 38.004 22.1352 37.96 22.4152 37.872C22.7032 37.776 22.9312 37.624 23.0992 37.416C23.2752 37.2 23.3632 36.92 23.3632 36.576C23.3632 36.064 23.1912 35.688 22.8472 35.448C22.5032 35.2 22.0472 35.076 21.4792 35.076H20.7712V33.948H21.4792C21.9352 33.948 22.3152 33.856 22.6192 33.672C22.9232 33.488 23.0752 33.168 23.0752 32.712C23.0752 32.312 22.9472 32.008 22.6912 31.8C22.4352 31.584 22.0432 31.476 21.5152 31.476C21.0032 31.476 20.6152 31.576 20.3512 31.776C20.0872 31.976 19.9312 32.248 19.8832 32.592L18.5512 32.52C18.6312 31.848 18.9232 31.308 19.4272 30.9C19.9392 30.492 20.6352 30.288 21.5152 30.288C22.1232 30.288 22.6432 30.384 23.0752 30.576C23.5072 30.76 23.8392 31.028 24.0712 31.38C24.3032 31.732 24.4192 32.144 24.4192 32.616C24.4192 33.136 24.2512 33.56 23.9152 33.888C23.5872 34.216 23.1032 34.44 22.4632 34.56V34.344C23.1592 34.432 23.7072 34.68 24.1072 35.088C24.5072 35.488 24.7072 36 24.7072 36.624C24.7072 37.16 24.5712 37.624 24.2992 38.016C24.0272 38.4 23.6512 38.692 23.1712 38.892C22.6912 39.092 22.1312 39.192 21.4912 39.192ZM26.3152 39V37.488H27.8632V39H26.3152ZM26.3152 34.428V32.916H27.8632V34.428H26.3152ZM33.3019 39V37.224H29.0059V36.12L33.1459 30.48H34.5979V36.048H35.6419V37.224H34.5979V39H33.3019ZM30.4819 36.048H33.3019V32.28L30.4819 36.048Z'
          fill='#FF6105'
        />
      </svg>
    ),
    width: 5400,
    height: 7200,
  },
  {
    name: 'Square',
    value: 'Square',
    svg: (
      <svg
        width='70'
        height='70'
        viewBox='0 0 70 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H68C68.8284 0.5 69.5 1.17157 69.5 2V68C69.5 68.8284 68.8284 69.5 68 69.5H2C1.17157 69.5 0.5 68.8284 0.5 68V2Z'
          stroke='#FF6105'
        />
        <path
          d='M30.5825 39V32.928H28.7825V31.884H29.5145C29.8345 31.884 30.0945 31.844 30.2945 31.764C30.4945 31.676 30.6385 31.532 30.7265 31.332C30.8145 31.124 30.8585 30.84 30.8585 30.48H31.8785V39H30.5825ZM34.2215 39V37.488H35.7695V39H34.2215ZM34.2215 34.428V32.916H35.7695V34.428H34.2215ZM39.0785 39V32.928H37.2785V31.884H38.0105C38.3305 31.884 38.5905 31.844 38.7905 31.764C38.9905 31.676 39.1345 31.532 39.2225 31.332C39.3105 31.124 39.3545 30.84 39.3545 30.48H40.3745V39H39.0785Z'
          fill='#FF6105'
        />
      </svg>
    ),
    width: 1650,
    height: 1650,
  },
  {
    name: 'Document',
    value: 'Document',
    svg: (
      <svg
        width='54'
        height='70'
        viewBox='0 0 54 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H52C52.8284 0.5 53.5 1.17157 53.5 2V68C53.5 68.8284 52.8284 69.5 52 69.5H2C1.17157 69.5 0.5 68.8284 0.5 68V2Z'
          stroke='#1395B5'
        />
        <path
          d='M11.4031 39V30.48H12.6991V38.52L12.0151 37.812H16.8511V39H11.4031ZM20.4616 39.144C19.8376 39.144 19.2976 39.008 18.8416 38.736C18.3936 38.464 18.0456 38.076 17.7976 37.572C17.5576 37.068 17.4376 36.48 17.4376 35.808C17.4376 35.136 17.5576 34.552 17.7976 34.056C18.0456 33.552 18.3936 33.164 18.8416 32.892C19.2896 32.612 19.8176 32.472 20.4256 32.472C21.0016 32.472 21.5096 32.608 21.9496 32.88C22.3896 33.144 22.7296 33.528 22.9696 34.032C23.2176 34.536 23.3416 35.144 23.3416 35.856V36.18H18.7576C18.7896 36.804 18.9536 37.272 19.2496 37.584C19.5536 37.896 19.9616 38.052 20.4736 38.052C20.8496 38.052 21.1616 37.964 21.4096 37.788C21.6576 37.612 21.8296 37.376 21.9256 37.08L23.2456 37.164C23.0776 37.756 22.7456 38.236 22.2496 38.604C21.7616 38.964 21.1656 39.144 20.4616 39.144ZM18.7576 35.22H21.9976C21.9576 34.652 21.7936 34.232 21.5056 33.96C21.2256 33.688 20.8656 33.552 20.4256 33.552C19.9696 33.552 19.5936 33.696 19.2976 33.984C19.0096 34.264 18.8296 34.676 18.7576 35.22ZM26.8441 39C26.2361 39 25.7881 38.86 25.5001 38.58C25.2121 38.3 25.0681 37.864 25.0681 37.272V31.116H26.3401V37.176C26.3401 37.472 26.4041 37.676 26.5321 37.788C26.6601 37.9 26.8561 37.956 27.1201 37.956H28.0321V39H26.8441ZM24.0961 33.66V32.616H28.0321V33.66H24.0961ZM30.7201 39C30.1121 39 29.6641 38.86 29.3761 38.58C29.0881 38.3 28.9441 37.864 28.9441 37.272V31.116H30.2161V37.176C30.2161 37.472 30.2801 37.676 30.4081 37.788C30.5361 37.9 30.7321 37.956 30.9961 37.956H31.9081V39H30.7201ZM27.9721 33.66V32.616H31.9081V33.66H27.9721ZM35.6374 39.144C35.0134 39.144 34.4734 39.008 34.0174 38.736C33.5694 38.464 33.2214 38.076 32.9734 37.572C32.7334 37.068 32.6134 36.48 32.6134 35.808C32.6134 35.136 32.7334 34.552 32.9734 34.056C33.2214 33.552 33.5694 33.164 34.0174 32.892C34.4654 32.612 34.9934 32.472 35.6014 32.472C36.1774 32.472 36.6854 32.608 37.1254 32.88C37.5654 33.144 37.9054 33.528 38.1454 34.032C38.3934 34.536 38.5174 35.144 38.5174 35.856V36.18H33.9334C33.9654 36.804 34.1294 37.272 34.4254 37.584C34.7294 37.896 35.1374 38.052 35.6494 38.052C36.0254 38.052 36.3374 37.964 36.5854 37.788C36.8334 37.612 37.0054 37.376 37.1014 37.08L38.4214 37.164C38.2534 37.756 37.9214 38.236 37.4254 38.604C36.9374 38.964 36.3414 39.144 35.6374 39.144ZM33.9334 35.22H37.1734C37.1334 34.652 36.9694 34.232 36.6814 33.96C36.4014 33.688 36.0414 33.552 35.6014 33.552C35.1454 33.552 34.7694 33.696 34.4734 33.984C34.1854 34.264 34.0054 34.676 33.9334 35.22ZM39.8063 39V32.616H40.9703L41.0183 34.308L40.9103 34.272C40.9983 33.696 41.1743 33.276 41.4383 33.012C41.7103 32.748 42.0743 32.616 42.5303 32.616H43.1423V33.756H42.5303C42.2103 33.756 41.9423 33.808 41.7263 33.912C41.5103 34.016 41.3463 34.176 41.2343 34.392C41.1303 34.608 41.0783 34.888 41.0783 35.232V39H39.8063Z'
          fill='#13A3B5'
        />
      </svg>
    ),
    width: 2550,
    height: 3300,
  },
  {
    name: 'Envelope',
    value: 'Envelope',
    svg: (
      <svg
        width='52'
        height='70'
        viewBox='0 0 52 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1 2C1 1.17157 1.67157 0.5 2.5 0.5H49.5C50.3284 0.5 51 1.17157 51 2V68C51 68.8284 50.3284 69.5 49.5 69.5H2.5C1.67157 69.5 1 68.8284 1 68V2Z'
          stroke='#992BFF'
        />
        <path
          d='M19.24 39L22.312 30.48H23.956L27.028 39H25.648L24.868 36.78H21.388L20.62 39H19.24ZM21.796 35.604H24.472L23.128 31.716L21.796 35.604ZM28.2362 39C28.2362 38.12 28.3522 37.252 28.5842 36.396C28.8242 35.532 29.1602 34.704 29.5922 33.912C30.0322 33.112 30.5562 32.364 31.1642 31.668H26.4002V30.48H32.5322V31.584C31.8602 32.352 31.3002 33.12 30.8522 33.888C30.4122 34.648 30.0842 35.448 29.8682 36.288C29.6602 37.12 29.5562 38.024 29.5562 39H28.2362Z'
          fill='#992BFF'
        />
      </svg>
    ),
    width: 1575,
    height: 2175,
  },
  {
    name: 'Phone',
    value: 'Phone',
    svg: (
      <svg
        width='40'
        height='70'
        viewBox='0 0 40 70'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1 2C1 1.17157 1.67157 0.5 2.5 0.5H37.5C38.3284 0.5 39 1.17157 39 2V68C39 68.8284 38.3284 69.5 37.5 69.5H2.5C1.67157 69.5 1 68.8284 1 68V2Z'
          stroke='#E94FBD'
        />
        <path
          d='M24.5 24.5H15.5C14.9033 24.5 14.331 24.7371 13.909 25.159C13.4871 25.581 13.25 26.1533 13.25 26.75V43.25C13.25 43.8467 13.4871 44.419 13.909 44.841C14.331 45.2629 14.9033 45.5 15.5 45.5H24.5C25.0967 45.5 25.669 45.2629 26.091 44.841C26.5129 44.419 26.75 43.8467 26.75 43.25V26.75C26.75 26.1533 26.5129 25.581 26.091 25.159C25.669 24.7371 25.0967 24.5 24.5 24.5ZM14.75 29H25.25V41H14.75V29ZM15.5 26H24.5C24.6989 26 24.8897 26.079 25.0303 26.2197C25.171 26.3603 25.25 26.5511 25.25 26.75V27.5H14.75V26.75C14.75 26.5511 14.829 26.3603 14.9697 26.2197C15.1103 26.079 15.3011 26 15.5 26ZM24.5 44H15.5C15.3011 44 15.1103 43.921 14.9697 43.7803C14.829 43.6397 14.75 43.4489 14.75 43.25V42.5H25.25V43.25C25.25 43.4489 25.171 43.6397 25.0303 43.7803C24.8897 43.921 24.6989 44 24.5 44Z'
          fill='#E94FBD'
        />
      </svg>
    ),
    width: 1080,
    height: 1920,
  },
  {
    name: 'Desktop',
    value: 'Desktop',
    svg: (
      <svg
        width='70'
        height='40'
        viewBox='0 0 70 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.5 2.5C0.5 1.67157 1.17157 1 2 1H68C68.8284 1 69.5 1.67157 69.5 2.5V37.5C69.5 38.3284 68.8284 39 68 39H2C1.17157 39 0.5 38.3284 0.5 37.5V2.5Z'
          stroke='#E94FBD'
        />
        <path
          d='M42.5 11.75H27.5C26.9033 11.75 26.331 11.9871 25.909 12.409C25.4871 12.831 25.25 13.4033 25.25 14V24.5C25.25 25.0967 25.4871 25.669 25.909 26.091C26.331 26.5129 26.9033 26.75 27.5 26.75H34.25V28.25H32C31.8011 28.25 31.6103 28.329 31.4697 28.4697C31.329 28.6103 31.25 28.8011 31.25 29C31.25 29.1989 31.329 29.3897 31.4697 29.5303C31.6103 29.671 31.8011 29.75 32 29.75H38C38.1989 29.75 38.3897 29.671 38.5303 29.5303C38.671 29.3897 38.75 29.1989 38.75 29C38.75 28.8011 38.671 28.6103 38.5303 28.4697C38.3897 28.329 38.1989 28.25 38 28.25H35.75V26.75H42.5C43.0967 26.75 43.669 26.5129 44.091 26.091C44.5129 25.669 44.75 25.0967 44.75 24.5V14C44.75 13.4033 44.5129 12.831 44.091 12.409C43.669 11.9871 43.0967 11.75 42.5 11.75ZM27.5 13.25H42.5C42.6989 13.25 42.8897 13.329 43.0303 13.4697C43.171 13.6103 43.25 13.8011 43.25 14V21.5H26.75V14C26.75 13.8011 26.829 13.6103 26.9697 13.4697C27.1103 13.329 27.3011 13.25 27.5 13.25ZM42.5 25.25H27.5C27.3011 25.25 27.1103 25.171 26.9697 25.0303C26.829 24.8897 26.75 24.6989 26.75 24.5V23H43.25V24.5C43.25 24.6989 43.171 24.8897 43.0303 25.0303C42.8897 25.171 42.6989 25.25 42.5 25.25Z'
          fill='#E94FBD'
        />
      </svg>
    ),
    width: 1920,
    height: 1080,
  },
  {
    name: 'Flyer',
    value: 'Flyer',
    svg: (
      <Image
        src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/b4f8817d-dd14-4b07-b94f-a9b9234bc000/public'
        className='h-[4.375rem] w-[3.375rem]'
        alt='Flyer'
        width={2550}
        height={3300}
      />
    ),
    width: 2550,
    height: 3300,
  },
  {
    name: 'Postcard',
    value: 'Postcard',
    svg: (
      <Image
        src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/7891b57b-7dce-4e06-eb99-45652ac67600/public'
        className='h-[3.4375rem] w-[4.375rem]'
        alt='Flyer'
        width={1650}
        height={1290}
      />
    ),
    width: 1650,
    height: 1290,
  },
  {
    name: 'Business Card',
    value: 'Business Card',
    svg: (
      <Image
        src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/5c4cc1e1-d631-4173-2164-dd3a3d714d00/public'
        className='h-[2.5rem] w-[4.375rem]'
        alt='Flyer'
        width={1050}
        height={600}
      />
    ),
    width: 1050,
    height: 600,
  },
];

export type AspectName =
  | 'Freeform'
  | 'Instagram Story'
  | 'Instagram Post'
  | 'Instagram Reel'
  | 'TikTok Video'
  | 'Facebook Post'
  | 'Facebook Cover'
  | 'Youtube Thumbnail'
  | 'Youtube Intro'
  | 'LinkedIn Background'
  | 'Presentation'
  | 'Poster'
  | 'Square'
  | 'Document'
  | 'Envelope'
  | 'Phone'
  | 'Desktop'
  | 'Flyer'
  | 'Postcard'
  | 'Business Card';
